import * as React from 'react';

export interface IProductListRowShimmerProps {
    className?: string;
}

function randomWidth(min: number, max: number): number {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

const ProductListRowShimmer: React.FC<IProductListRowShimmerProps> = (props) => {
    const {
        className
    } = props;

    const categoryWidth = React.useMemo(() => randomWidth(33, 171), []);
    const producerWidth = React.useMemo(() => randomWidth(50, 145), []);
    const nameWidth = React.useMemo(() => randomWidth(130, 405), []);
    const conversionWidth = React.useMemo(() => randomWidth(16, 81), []);
    const skuWidth = React.useMemo(() => randomWidth(43, 50), []);
    const brandWidth = React.useMemo(() => randomWidth(28, 80), []);
    const priceWidth = React.useMemo(() => randomWidth(96, 116), []);

    return (
        <li>
            <div className={`${className}__product-image`}>
                <div className={`${className}__product-image__shimmer`} />
            </div>

            <div className={`${className}__product-wrapper`}>
                <div className={`${className}__product`}>
                    <div className={`${className}__product__shimmer-line`} style={{ width: categoryWidth }} />
                    <div className={`${className}__product__shimmer-line`} style={{ width: producerWidth }} />
                    <div className={`${className}__product__shimmer-line`} style={{ width: nameWidth, height: 24 }} />
                    <div className={`${className}__product__shimmer-line`} style={{ width: conversionWidth }} />
                    <div className={`${className}__product__shimmer-line`} style={{ width: skuWidth }} />
                    <div className={`${className}__product__shimmer-line`} style={{ width: brandWidth }} />
                    <div className={`${className}__product__shimmer-line`} style={{ width: 75, height: 28, marginTop: 'auto' }} />
                </div>
            </div>

            <div className={`${className}__right`}>
                <div className={`${className}__price-and-indicators`}>
                    <div className={`${className}__prices-wrapper`}>
                        <div className={`${className}__product__shimmer-line`} style={{ width: priceWidth, height: 29 }} />
                        <div className={`${className}__product__shimmer-line`} style={{ width: 115, height: 15 }} />
                    </div>
                </div>

                <div className={`${className}__product__shimmer-line`} style={{ width: '100%', height: 29 }} />
                <div className={`${className}__product__shimmer-line`} style={{ width: 144, height: 42 }} />
            </div>
        </li>
    );
};

export default ProductListRowShimmer;
